import { lazy } from 'react'
import BasicLayout from '../components/layout/BasicLayout'
import routerConstants from '../constants/routerConstants'

const routeRoleAssignmentCopy: any[] = [
  { path: routerConstants.copyRoleAssignment.copy, name: 'copyRoleAssignmentCopy', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/roleAssignmentCopy/RoleAssignmentCopy')), },
]
export { routeRoleAssignmentCopy }